import { render, staticRenderFns } from "./macMingxi.vue?vue&type=template&id=86ca542c&scoped=true"
import script from "./macMingxi.vue?vue&type=script&lang=js"
export * from "./macMingxi.vue?vue&type=script&lang=js"
import style0 from "./macMingxi.vue?vue&type=style&index=0&id=86ca542c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ca542c",
  null
  
)

export default component.exports